import React, { useEffect, useState } from "react";
import AppointmentCard from "../../../../components/common/appointmentCard";
import { useDispatch, useSelector } from "react-redux";
import { fetchAppointments } from "../../../../store/slices/appointmentSlice";
import { Pagination, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
const Appointment = () => {
  const [render, setRender] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPagesize] = useState(3);
  const appointmentsSelect = useSelector((state) => state?.appointment);
  const appointmentData = appointmentsSelect?.value;
  const text = useSelector((state) => state?.text?.value);
  const dispatch = useDispatch();

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const handleSizeChange = (current, size) => {
    setPagesize(size);
  };
  const payload = {
    pageNumber: currentPage,
    pageSize: pageSize,
    text: text || null,
  };
  useEffect(() => {
    dispatch(fetchAppointments(payload));
  }, [currentPage, pageSize, render, dispatch, text]);
  if (appointmentsSelect?.isLoading) {
    return (
      <div className="flex h-screen justify-center items-center">
        <Spin
          indicator={<LoadingOutlined />}
          className="flex justify-center"
          size="large"
        />
      </div>
    );
  }
  if (!appointmentData?.totalItems) {
    return (
      <div className="flex justify-center opacity-50 mt-20">
        <h1 className="text-xl flex justify-center mr-2 mt-0.4">
          No Appointments Yet
        </h1>
      </div>
    );
  }

  return (
    <>
      <div className="m-3">
        <div className="mb-4 ">
          {appointmentData?.items?.map((data, i) => (
            <AppointmentCard
              setRender={setRender}
              render={render}
              key={i}
              data={data}
            />
          ))}
        </div>
        <div className="flex justify-center items-center pagination-container mb-2">
          <Pagination
            current={currentPage}
            total={appointmentData?.totalItems}
            pageSize={pageSize}
            onShowSizeChange={handleSizeChange}
            pageSizeOptions={[3, 10, 20, 30]}
            onChange={(e) => {
              handlePageChange(e);
            }}
          />
        </div>
      </div>
    </>
  );
};

export default Appointment;
